<template>
  <div>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
      <el-form-item>
        <el-select v-model="searchForm.table_name" style="width: 100px;background-color: #4B4F56;color: white;" placeholder="请选择搜索范围">
          <el-option
              v-for="item in tableNames"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.keyword" style="width: 200px;background-color: #4B4F56;color: white;" placeholder="请输入关键词"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit"
                   style="background-color: #2ECD81;border-color: #2ECD81;color:white ">查询
        </el-button>
      </el-form-item>
    </el-form>

    <div class="block">
      <span class="demonstration" style="margin-right: 200px;color: #9FA3AD;font-size: 13px;margin-left: 20px;">{{ hit_info }}</span>
    </div>

    <!--    <div class="tag-group" v-if="agg_dbs">-->
    <!--      <span class="tag-group__title" style="color: white">数据库</span>-->
    <!--      <el-tag-->
    <!--          v-for="item in agg_dbs"-->
    <!--          :key="item.key"-->
    <!--          @click="handleChangeDbSel(item)"-->
    <!--          effect="dark">-->
    <!--        {{ item.key }}({{ item.doc_count }})-->
    <!--      </el-tag>-->
    <!--    </div>-->
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix" style="border: none">
        <i class="el-icon-card-header"></i>
        <span>数据列表一览</span>
      </div>
      <el-table :data="resultTbl" :header-cell-style="{background:'#363944',color:'white',border:'none'}"
                :row-class-name="tableRowClassName"
                style="width: 100%;" v-if="total_record">
        <el-table-column type="index" prop="order" label="序号" width="120" align="center">
        </el-table-column>
        <el-table-column label="数据库" align="center" prop="数据库" v-if="false"/>
        <el-table-column label="表名" align="center" prop="表名" v-if="false"/>
        <el-table-column label="entity_id" align="center" prop="entity_id" v-if="false"/>

        <el-table-column v-for="column in result_columns" :key="column.label" :prop="column.prop"
                         :label="column.label">
          <template slot-scope="scope"  >
            <div v-html="scope.row[column.prop].substring(0, 1)+'******'" v-if="isDemo && (column.prop.indexOf('phone')!=-1 || column.prop.indexOf('name')!=-1)"></div>
            <div v-html="scope.row[column.prop]" v-else></div>
<!--            <div v-html="scope.row[column.prop].substring(0, 1)+'******'" v-else></div>-->
          </template>

        </el-table-column>

        <el-table-column
            
            label="操作" v-if="searchForm.table_name!='western_medicine_public'"
            width="160">
          <template slot-scope="scope">
            <el-button @click="open_detail(scope.row)" type="text" size="small" style="color: #5CEAA8">详情</el-button>
            <el-button @click="do_mixup(scope.row)" type="text" size="small" style="color: #1FBBD6">脱敏</el-button>
            <el-button @click="do_fillup(scope.row)" type="text" size="small"
                       v-if="searchForm.table_name=='patient'" style="color: #F37487">补全
            </el-button>
            <el-button @click="do_trace(scope.row)" type="text" size="small" style="color: #2B7DF8">溯源</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination v-if="total_record"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page.sync="searchForm.page_num"
                       :page-sizes="[100, 200, 300, 400]"
                       :page-size="100"
                       layout="sizes, prev, pager, next"
                       :total="total_record">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import {Role} from "@/role";

export default {
  name: "DataSearch",
  data() {
    return {
      searchForm: {
        keyword: '诊所',
        page_num: 1,
        page_size: 100,
        db_name: '',
        table_name: 'clinic',
      },
      resultTbl: [],
      result_columns: [],
      hit_info: "",
      total_record: null,
      agg_dbs: null,
      tableNames: [{
        value: 'clinic',
        label: '诊所'
      }, {
        value: 'jb',
        label: '疾病'
      }, {
        value: 'zy',
        label: '中药'
      }, {
        value: 'zcy',
        label: '中成药'
      }, {
        value: 'western_medicine_public',
        label: '西药'
      }, {
        value: 'patient',
        label: '患者'
      }, {
        value: 'doctor',
        label: '医生'
      },]
    }
  },
  mounted() {
    this.onSubmit1();
  },
  computed: {
    isDemo: function () {
      return this.$store.getters.user_role === Role.Demo
    },
  },
  methods: {
    do_mixup(row) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/do_mixup",
          row, {"content-type": "application/json"}).then((res) => {
        const result = res.data.data;
        for (let key in result) {
          row[key] = result[key]
        }
      })
    },
    do_fillup(row) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/do_fillup",
          row, {"content-type": "application/json"}).then((res) => {
        row['patient_address'] = res.data.data
      })
    },
    do_trace(row) {
      this.$http.post(process.env.VUE_APP_API_HOST + "/do_trace",
          row, {"content-type": "application/json"}).then((res) => {
        const result = res.data.data;
        let msg = ''
        for (let key in result) {
          row[key] = result[key]
          msg += "<font color='red'><strong>" + key + "</strong></font>：" + result[key] + "<br>"
        }

        this.$alert(msg, '溯源结果', {
          dangerouslyUseHTMLString: true
        });
      })
    },
    open_detail(row) {
      console.log(row);
      // if (row['表名'] == 'jb') {
      //   window.open(process.env.VUE_APP_API_HOST +"/detail?sign=364e871999443224dfba2b245cd67fe8&dbName=jb&dataId=" + row.entity_id, '_blank');
      // } else if (row['表名'] == 'zcy') {
      //   window.open(process.env.VUE_APP_API_HOST +"/detail?sign=364e871999443224dfba2b245cd67fe8&dbName=zcy&dataId=" + row.entity_id, '_blank');
      // } else if (row['表名'] == 'zy') {
      //   window.open(process.env.VUE_APP_API_HOST +"/detail?sign=364e871999443224dfba2b245cd67fe8&dbName=zy&dataId=" + row.entity_id, '_blank');
      // } else if (row['表名'] == 'patient') {
      //   // window.open(process.env.VUE_APP_WEB_HOST + "/home?patient_id=" + row.patient_id, '_blank');
      //   this.$router.push({path: '/patient/basic', query: {"patient_id": row.patient_id}});
      // } else if (row['表名'] == 'clinic') {
      //   this.$router.push({path: '/clinic/clinic_info', query: {"clinic_id": row.clinic_id, "doctor_id": '-1'}});
      //   // window.open(process.env.VUE_APP_WEB_HOST + "/clinic?doctor_id=-1&clinic_id=" + row.clinic_id, '_blank');
      // } else if (row['表名'] == 'doctor') {
        // /clinic/clinic_info?clinic_id=1634156525020430341
        this.$router.push({
          path: '/clinic/clinic_info',
          query: {"clinic_id": row.clinic_id, "doctor_id": row.doctor_id,}
        });
      //   // window.open(process.env.VUE_APP_WEB_HOST + "/clinic?clinic_id=-1&doctor_id=" + row.doctor_id, '_blank');
      // }
    },
    handleChangeDbSel(val) {
      this.searchForm.db_name = val.key;
      this.onSubmit1();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.searchForm.page_size = val;

      this.onSubmit1();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.searchForm.page_num = val;

      this.onSubmit1();
    },
    onSubmit() {
      this.searchForm.db_name = "";
      this.searchForm.page_num = 1;
      this.onSubmit1();
    },
    onSubmit1() {
      this.$http.post(process.env.VUE_APP_API_HOST + "/search_all",
          this.searchForm, {"content-type": "application/json"}).then((res) => {
        this.resultTbl = res.data.search_result;
        this.result_columns = res.data.result_columns;
        this.hit_info = res.data.hit_info;
        this.total_record = res.data.total_record;
        this.agg_dbs = res.data.agg_info_db;

      })
    },

    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 1) {
        return 'warning-row1';
      } else if (rowIndex % 2 == 0) {
        return 'success-row1';
      }
      return '';
    },
  }
}


</script>

<style scoped>
.el-form {
  margin-top: 10px;
  /* text-align: center; */
}

.el-form-item {
  text-align: center;
}

.el-tag {

  margin-left: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.el-table /deep/ tbody tr:hover {
  color: black !important
}

.el-table /deep/ .warning-row1 {
  background: #363944;
}

.el-table /deep/ .warning-row1 > td {
  border: none;
}

.el-table /deep/ .success-row1 {
  background: #3C3F4A;
}

.el-table /deep/ .success-row1 > td {
  border: none;
}

.el-card /deep/ .el-card__header {
  border-bottom: none;
  height: 40px;
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  background-color: #363944;
}
</style>
